module.exports = __webpack_public_path__ + "static/media/TeamBlue.8c08b48b.png";